import React from 'react';
import PropTypes from 'prop-types';

import ButtonDeprecated from 'core/gd-components/buttons/gd-button/gd-button';

class NotificationMessage extends React.Component {
    static propTypes = {
        message: PropTypes.any,
        btnLabel: PropTypes.string
    };

    onClick = () => {
        this.props.onSubmit();
    };

    render() {
        const { message, btnLabel } = this.props;

        let res;
        if (typeof message === 'string') {
            res = (
                <div className="description">
                    {message.split('\n').map((item, key) => {
                        return <span key={key}>{item}<br/></span>
                    })}
                </div>
            );
        } else {
            res = message;
        }

        return (
            <div className="block">
                <div className="i5-emergency-solid"/>
                {res}
                <div className="actions">
                    <ButtonDeprecated label={btnLabel ? btnLabel : "Ok"}
                                      onClick={this.onClick} type="primary"/>
                </div>
            </div>
        );
    }
}

module.exports = NotificationMessage;
